
(() => {
    console.log('%c👍🏼 Sticky Tabs', 'color: yellow');
    const stickyTabs = document.querySelectorAll('.sticky_tabs');
    stickyTabs.forEach(function(stickyTab) {
            
        const tabs = stickyTab.querySelectorAll('.sticky-tabs__tab');
        const sections = stickyTab.querySelectorAll('.sticky-tabs__section');

        // Debounce function
            function debounce(func, wait) {
                let timeout;
                return function executedFunction(...args) {
                const later = () => {
                    clearTimeout(timeout);
                    func(...args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                };
            }

            // Function to measure empty space and apply margin
            function calculateEmptySpace() {
                const lastSection = sections[sections.length - 1];
                if (window.innerWidth < 640) {
                    stickyTab.style.marginBottom = '';
                }
                else if (lastSection) {
                    const lastSectionRect = lastSection.getBoundingClientRect();
                    const lastChild = lastSection.lastElementChild;
                    const lastElRect = lastChild.getBoundingClientRect();
                    const emptySpace = (lastSectionRect.bottom - lastElRect.bottom)/2;
                    
                    if (emptySpace > 0) {
                        stickyTab.style.marginBottom = `-${emptySpace}px`;
                    } else {
                        stickyTab.style.marginBottom = '';
                    }
                }
            }

            // Initial calculation
            calculateEmptySpace();

            // Debounced resize listener
            const debouncedCalculate = debounce(calculateEmptySpace, 250);
            window.addEventListener('resize', debouncedCalculate);
        
        // Add active class to tabs when clicked
        tabs.forEach(tab => {
            tab.addEventListener('click', (e) => {
                e.preventDefault();
                
                // Remove active class from all tabs
                tabs.forEach(t => t.classList.remove('active'));
                
                // Add active class to clicked tab
                tab.classList.add('active');
                
                // Scroll to target section
                const targetId = tab.getAttribute('data-target');
                const targetSection = stickyTab.querySelector(targetId);

                if (targetSection) {
                    console.log('targetSection', targetSection);
                    targetSection.scrollIntoView({ behavior: 'smooth' });
                }
            });
        });

        // Add active class to sections when scrolled into view and at top of window
        sections.forEach(section => {
            const observer = new IntersectionObserver((entries, options) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // Remove active class from all tabs
                        // console.log('entry', entry);
                        tabs.forEach(t => {
                            t.classList.remove('active', 'opacity-100')
                            t.classList.add('opacity-20')
                        });
                        
                        // Add active class to the corresponding tab
                        const targetTab = stickyTab.querySelector(`.sticky-tabs__tab[data-target="#${section.id}"]`);
                        if (targetTab) {
                            targetTab.classList.add('active', 'opacity-100');
                            targetTab.classList.remove('opacity-20');
                        }
                    }
                });
            },{
                rootMargin: "-50% 0px -100% 0px",
                // Trigger when any part of the element is visible
                threshold: 0
              });

            observer.observe(section);
        });
    });
})();
